import { z } from 'zod';
export const availableColumnTypes = [
    // 'bigIncrements',
    'bigInteger',
    'binary',
    'boolean',
    'char',
    'dateTime',
    'date',
    'decimal',
    'double',
    'enum',
    'float',
    'foreignId',
    // 'id',
    // 'increments',
    'integer',
    // 'json',
    'longText',
    // 'mediumIncrements',
    'mediumInteger',
    'mediumText',
    // 'morphs',
    // 'nullableMorphs',
    // 'nullableTimestamps',
    // 'nullableUuidMorphs',
    // 'smallIncrements',
    'smallInteger',
    // 'softDeletes',
    'string',
    'text',
    'time',
    'timestamp',
    // 'tinyIncrements',
    'tinyInteger',
    'tinyText',
    // 'unsignedBigInteger',
    // 'unsignedDecimal',
    // 'unsignedInteger',
    // 'unsignedMediumInteger',
    // 'unsignedSmallInteger',
    // 'unsignedTinyInteger',
    // 'uuidMorphs',
    // 'ulid',
    'uuid',
    'year',
];
export const availableRelationTypes = [
    'BelongsTo',
    'BelongsToMany',
    'HasMany',
    // 'HasManyThrough',
    'HasOne',
    // 'HasOneThrough',
    // 'MorphedByMany',
    // 'MorphMany',
    // 'MorphOne',
    // 'MorphTo',
    // 'MorphToMany',
];
export const columnSchema = z.object({
    type: z.enum(availableColumnTypes).describe('The column type'),
    typeConstraints: z
        .array(z.object({
        type: z.enum(['parameter', 'modifier', 'validator']).describe('The type of the constraint'),
        name: z.string().describe('The constraint name'),
        params: z.array(z.union([z.string(), z.number()])).describe('The constraint params'),
    }))
        .optional(),
    guarded: z.boolean().describe('Is the column guarded?').optional(),
    hidden: z.boolean().describe('Is the column hidden?').optional(),
    cast: z.string().describe('The column cast type').optional(),
    searchable: z.boolean().describe('The column should be searchable').optional(),
    displayName: z.string().describe('The column pretty display name'),
    displayNamePlural: z.string().describe('The column pretty display name in plural form'),
    order: z.number().describe('The column order'),
});
export const relationSchema = z.object({
    relationType: z.enum(availableRelationTypes).describe('The type of the relationship'),
    model: z.string().describe('The related model'),
    inverse: z.string().describe('The inverse relation name'),
});
export const modelSchema = z.object({
    name: z.string().describe('The model name (PascalCase) e.g. User, Post, Comment, etc.'),
    namePlural: z
        .string()
        .describe('The model name in plural form (PascalCase) e.g. Users, Posts, Comments, etc.'),
    table: z.string().describe('The database table name e.g. users, posts, comments, etc.'),
    route: z.string().describe('The model base route e.g. users, posts, comments, etc.'),
    title: z
        .string()
        .describe('The column key of the columns that can be used as title by default to differentiate different model instances of the frontend e.g. email, username, etc.'),
    subtitle: z
        .string()
        .describe('The column key of the columns that can be used as subtitle by default to differentiate different model instances of the frontend e.g. email, username, etc.')
        .nullable(),
    columns: z
        .record(z.string(), columnSchema)
        .describe("The columns in the module's database table"),
    relations: z.record(z.string(), relationSchema).describe('The model relations'),
});
export const moduleSchemaSchema = z.object({
    model: modelSchema,
    order: z.number().describe('The module order index'),
});
